import React from 'react';
import Typography from '@mui/material/Typography';

// Staff review context only; the shared RoundView/MiniTaskDialogue still render
// the question. Missing technical media registration never hides a question.
export default function SchoolLifeReviewStatus({ question }) {
  const status = question?.staff_review;
  if (!status) return null;
  const messages = [status.content_id];
  if (!status.student_active) messages.push('Öğrenciye kapalı');
  if (status.editorial_hold) messages.push('Editoryal inceleme bekliyor');
  if (status.image_registration_pending) messages.push('Görsel kaydı bekleniyor');
  if (status.audio_registration_pending) messages.push('Ses onaylı; oynatma kaydı bekleniyor');
  return <Typography role="status" sx={{ color: '#334155', fontSize: 13, lineHeight: 1.5, mb: 0.75 }}>
    {messages.filter(Boolean).join(' · ')}
  </Typography>;
}
